// var iosInnerHeight = require('ios-inner-height')
var SafariMixin = {
  data () {
    return {
      ahint: null,
      ah: 0
    }
  },
  methods: {
    appHeight () {
      var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      var ih = (iOS) ? document.body.clientHeight : window.innerHeight;

      var resizers = document.getElementsByClassName('hresize')
      Array.from(resizers).forEach((r) => {
        r.style.height = ih + 'px'
      })

      var resizers2 = document.getElementsByClassName('hresize-t')
      Array.from(resizers2).forEach((r) => {
        r.style.height = (ih - 40) + 'px'
      })

      //console.log(ih)
    }
  },
  mounted ()  {
    // window.addEventListener('resize', this.appHeight)
    this.appHeight()
    this.ahint = setInterval(() => {
      this.appHeight()
    }, 1000)
  }
}

export default SafariMixin
